import type { GeneratedSchemaKind } from '@cli-types/core-engine/add-field.js'
import type { SchemaField } from '@cli-types/core-engine/schema.js'
import type { PromptFieldOptions, SchemaPromptContext } from '@cli-types/next-adapter/commands.js'
import { applyAdvancedOptions } from './apply-advanced-options.js'
import { promptChildFields } from './prompt-child-fields.js'

export async function promptSchemaContainerField(
  context: SchemaPromptContext,
  kind: GeneratedSchemaKind,
  schemasDir: string,
  scope: 'schema' | 'list-item',
  name: string,
  label: string,
  type: string,
  depth: number,
  options: PromptFieldOptions
): Promise<SchemaField> {
  const field = {
    name,
    type,
    label,
    fields: []
  } as SchemaField

  await applyAdvancedOptions(context, field, kind, type, options)
  await promptChildFields(
    context,
    kind,
    schemasDir,
    type === 'list' ? 'list-item' : scope,
    field.fields!,
    depth,
    options
  )
  return field
}
